<template>
  <div class="landing-view">
    <section id="landing-intro" class="section">
      <div class="container">
        <div class="row">
          <div class="align-col-center col-md-12">
            <h1>Design the way you want with Easy Design-In Tool</h1>
            <p>
              The Easy Design-In Tool is designed specifically for you. Come see
              the new Playground and with just a few clicks create the lighting
              system of your choice. Explore what we have to offer!
            </p>
          </div>
        </div>

        <carousel
          :per-page="3"
          :per-page-custom="[
            [320, 1],
            [900, 3],
          ]"
          :navigation-enabled="true"
          :navigation-next-label="'&#10095;'"
          :navigation-prev-label="'&#10094;'"
        >
          <slide
            data-index="0"
            data-title="Compose a LED lighting system"
            data-video="HdWNcNkAtVs"
            @slideclick="handleSlideClick"
          >
            <div class="carousel-item">
              <img
                src="../assets/images/carousel/compose-a-led-lighting-system.png"
                alt="Compose a LED lighting system"
              />
              <div class="btn-video-play">
                <circle-play></circle-play>
              </div>
            </div>
          </slide>
          <slide
            data-index="0"
            data-title="Find a matching driver for your LED module"
            data-video="ITxIAgeVwLI"
            @slideclick="handleSlideClick"
          >
            <div class="carousel-item">
              <img
                src="../assets/images/carousel/find-a-matching-driver-for-your-led-module.png"
                alt="Find a matching driver for your LED module"
              />
              <div class="btn-video-play">
                <circle-play></circle-play>
              </div>
            </div>
          </slide>
          <slide
            data-index="0"
            data-title="How to find a product or family"
            data-video="C-i2Qt9knt0"
            @slideclick="handleSlideClick"
          >
            <div class="carousel-item">
              <img
                src="../assets/images/carousel/how-to-find-a-product-or-family.png"
                alt="How to find a product or family"
              />
              <div class="btn-video-play">
                <circle-play></circle-play>
              </div>
            </div>
          </slide>
          <slide
            data-index="0"
            data-title="Add emergency Lighting components to your system"
            data-video="iP7Jeh3bo1E"
            @slideclick="handleSlideClick"
          >
            <div class="carousel-item">
              <img
                src="../assets/images/carousel/add-emergency-lighting-components-to-your-system.png"
                alt="Add emergency lighting components to your system"
              />
              <div class="btn-video-play">
                <circle-play></circle-play>
              </div>
            </div>
          </slide>
          <slide
            data-index="0"
            data-title="How to combine linear modules of different lengths"
            data-video="Ss7k9-bK-qY"
            @slideclick="handleSlideClick"
          >
            <div class="carousel-item">
              <img
                src="../assets/images/carousel/how-to-combine-linear-modules-of-different-lengths.png"
                alt="How to combine linear modules of different lengths"
              />
              <div class="btn-video-play">
                <circle-play></circle-play>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </section>
    <section id="landing-intro2" class="section bg-gray">
      <div class="container intro">
        <div class="row">
          <div class="align-col-center col-md-6">
            <h2>Playground: Design your solution with ease</h2>

            <p>
              Compose your desired lighting system by selecting the optimal LED
              driver and module, or find the right driver or module based on
              your specifications. The new Playground helps make this easier
              with the driver and the module now in the same view.
            </p>
            <div class="buttons">
              <button
                class="btn btn-secondary mt-2 mb-2"
                id="launch-edit-button"
                @click="toEdit"
              >
                Launch Easy Design-In Tool
              </button>
              <button
                v-if="!isLoggedIn"
                class="btn btn-outline-secondary mt-2 mb-2"
                @click="oidcSigninRedirect"
              >
                Login
              </button>
            </div>
          </div>
          <div class="col-md-6">
            <div class="image">
              <img
                src="../assets/images/Lading_1.png"
                alt="Easy Design-In Tool"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="landing-search" class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-12 search align-col-bottom">
            <h2>Enhanced Search function</h2>
            <p>
              We can help you find a specific product and then launch the Easy
              Design-In Tool or the Compose and Connect Configurator with that
              product selected.
            </p>
          </div>
          <div class="col-md-8 search align-col-bottom search-box">
            <h6>Product search</h6>
            <label>
              <search-svg class="search-icon" @click="onSearch(searchValue)" />
              <cross-svg
                v-if="hasSearchValue"
                class="cross-icon"
                @click="clearSearchValue"
              />
              <input
                type="text"
                class="form-control formGroupInput search-input"
                name="search"
                v-model="searchValue"
                placeholder="You can search for: module, driver, node, bridge, 12NC, etc"
                @keypress.enter="onSearch(searchValue)"
                autocomplete="off"
              />
            </label>
            <input
              type="button"
              class="btn btn-secondary"
              value="Search"
              @click="onSearch(searchValue)"
            />
          </div>
        </div>
      </div>
    </section>
    <section id="landing-guidme" class="section">
      <div class="container">
        <div class="row">
          <div class="align-col-center col-md-12">
            <h2>Guide me</h2>
            <p>
              The Guide me function will assist you with the selection process
              to design a system of your choice.
            </p>
            <div class="buttons">
              <button
                class="btn btn-secondary mt-2"
                v-modal-link="{ name: 'guide', props: { show: true } }"
              >
                Guide me
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <landing-footer></landing-footer>
    <video-modal
      :show="videoModalToggle"
      :modal-title="videoModalTitle"
      :modal-video="videoModalId"
      @closeModal="closeVideoModal"
    >
    </video-modal>
  </div>
</template>

<script>
import settings from "@/service/Settings";
import landingFooter from "./layout/Footer.vue";
import VideoModal from "@/components/modals/VideoModal";
import { mapActions, mapGetters, mapState } from "vuex";
import searchSvg from "@/assets/svg/icons/signify-icons_26-search-16px.svg?inline";
import crossSvg from "@/assets/svg/icons/signify-icons_15-cross-16px.svg?inline";
import circlePlay from "@/assets/svg/icons/signify-icons_44-circle.svg?inline";
import Guide from "@/views/guide/Guide";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "LandingView",
  modals: {
    Guide,
  },
  components: {
    landingFooter,
    VideoModal,
    searchSvg,
    crossSvg,
    circlePlay,
    Carousel,
    Slide,
  },
  data() {
    return {
      searchValue: "",
      environment: settings.ENV,
      sso_url: settings.PORTAL_TOOLS_SSO_URL,
      videoModalToggle: false,
      videoModalTitle: "",
      videoModalId: "",
    };
  },
  created() {
    this.$store.commit("brain/ui/showControls", false);
  },
  computed: {
    ...mapGetters("brain/auth", ["isLoggedIn"]),
    ...mapState("brain", ["region"]),
    hasSearchValue() {
      return this.searchValue !== "";
    },
  },
  methods: {
    onSearch(searchTerm) {
      this.$router.push({
        name: "search",
        params: { searchTerm: searchTerm, back: "/" },
      });
    },
    clearSearchValue() {
      this.searchValue = "";
    },
    toEdit() {
      this.$store.commit("brain/global/setCheckReload", true);
      this.$router.push({ name: "advanced" });
    },
    openSSOUrl() {
      window.location.href = this.sso_url;
    },
    handleSlideClick(dataset) {
      this.videoModalTitle = dataset.title;
      this.videoModalId = dataset.video;
      this.videoModalToggle = true;
    },
    closeVideoModal() {
      this.videoModalToggle = false;
    },
    ...mapActions("brain/auth", ["oidcSigninRedirect"]),
  },
};
</script>

<style lang="scss" scoped>
$bg-gray: #eaeaea;

#launch-edit-button {
  width: auto;
  max-width: 100%;
}
#compose-connect-button {
  width: auto;
  max-width: 100%;
}

.landing-view {
  overflow-x: hidden;
  position: relative;
  flex-grow: 2;

  $sectionPadding: 60px;

  .section {
    padding: $sectionPadding 0;
  }
}

.bg-gray {
  background-color: $bg-gray;
}

h1 {
  font-size: 42px;
}

h2 {
  margin-bottom: 2rem;
  color: #3c3c41;
  font-size: 34px;
}

.container-fluid {
  overflow: hidden;
}

p {
  color: #3c3c41;
}

label {
  width: 100%;
  position: relative;

  .search-input {
    padding-left: 36px;
  }

  .search-icon {
    width: 16px;
    position: absolute;
    top: 13px;
    left: 12px;
    cursor: pointer;

    path {
      fill: $dark-gray-800;
    }
  }

  .cross-icon {
    width: 16px;
    position: absolute;
    top: 13px;
    right: 12px;
    cursor: pointer;

    path {
      fill: $dark-gray-800;
    }
  }
}

.search-box {
  display: flex;
  flex-flow: row wrap;

  h6 {
    flex: 1 100%;
  }

  label {
    margin: 0 16px 0 0;
    flex: 4 0 0;
  }

  input {
    flex: 1 0 0;
  }
}

button {
  max-width: 175px;
  width: 100%;
}

.align-col-center {
  align-self: center;
}

.align-col-bottom {
  margin-top: auto;
}

.image {
  img {
    width: 100%;
    -webkit-box-shadow: 0px 12px 20px 5px rgba(60, 60, 65, 0.1);
    -moz-box-shadow: 0px 12px 20px 5px rgba(60, 60, 65, 0.1);
    box-shadow: 0px 12px 20px 5px rgba(60, 60, 65, 0.1);
  }
}

.video {
  width: 100%;
  height: 325px;
  background-color: #666;
}

.intro {
  flex-flow: column nowrap;
  .row {
    &:first-child {
      padding: 0;
    }
  }
  .buttons {
    button {
      &:first-child {
        margin: 0 1rem 0 0;
      }
    }
  }
}

.VueCarousel {
  .VueCarousel-slide {
    .carousel-item {
      margin: 10px;
      position: relative;

      img {
        width: 100%;
      }

      .btn-video-play {
        align-items: center;
        border-radius: 50%;
        border: 0px solid $white;
        box-shadow: 0 0 0 rgba($white, 0.4);
        cursor: pointer;
        display: flex;
        height: 50px;
        justify-content: center;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        z-index: 99;

        svg {
          opacity: 0.75;
          height: 40px;
          width: 40px;
        }

        &:hover {
          animation: sppPulse 2s infinite;
        }
      }
    }
  }
  ::v-deep {
    .VueCarousel-navigation-button {
      font-size: 60px;

      &.VueCarousel-navigation-prev {
        transform: translateY(-75%) translateX(-100%);
      }
      &.VueCarousel-navigation-next {
        transform: translateY(-75%) translateX(100%);
      }
    }
    .VueCarousel-pagination {
      .VueCarousel-dot {
        margin-top: 0 !important;
        outline: none !important;
      }
    }
  }
}

@keyframes sppPulse {
  0% {
    box-shadow: 0 0 0 0 rgba($white, 0.4);
  }
  70% {
    box-shadow: 0 0 0 20px rgba($white, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba($white, 0);
  }
}
</style>
